import Ajv from 'ajv';
import type { KeywordDefinition } from 'ajv';
import ajvFormats from 'ajv-formats';
import { DateProperty } from 'shared';

export const dateRange: KeywordDefinition = {
  keyword: 'dateRange',
  type: 'string',
  validate(schema: DateProperty['dateRange'], data: string) {
    if (schema == null) {
      return true;
    }

    // 日付としておかしい場合は、validとして返す
    // そうでないと、不正な文字列のときも比較が行われてしまうため
    const ajv = ajvFormats(
      new Ajv({
        validateSchema: false,
        formats: {
          date: true,
        },
        unicodeRegExp: false,
        code: {
          es5: true,
        },
      }),
      ['date']
    );
    const isValidDate = ajv.validate({ type: 'string', format: 'date' }, data);
    if (!isValidDate) {
      return true;
    }

    if (schema.min != null && data < schema.min) {
      return false;
    }
    if (schema.max != null && data > schema.max) {
      return false;
    }
    return true;
  },
};
